/**
 * Loads GuideJar after the React app has mounted to avoid third-party script
 * racing or conflicting with React (often surfaces as minified React errors).
 *
 * Disable entirely: REACT_APP_GUIDEJAR=false
 * Force load (e.g. local repro): REACT_APP_GUIDEJAR=true npm start
 */
const WIDGET_SCRIPT_URL = "https://cdn.guidejar.com/helpcenter-widget-5b75.min.js";
const WIDGET_SCRIPT_ID = "guidejar-widget-script";
const LOAD_GUARD_KEY = "guidejarWidgetLoaded";

function shouldLoadGuideJar() {
  if (process.env.REACT_APP_GUIDEJAR === "false") {
    return false;
  }
  if (process.env.REACT_APP_GUIDEJAR === "true") {
    return true;
  }
  if (process.env.NODE_ENV !== "production") {
    return false;
  }
  const host = window.location.hostname;
  if (host === "localhost" || host === "127.0.0.1" || host === "0.0.0.0") {
    return false;
  }
  return true;
}

function alreadyLoaded() {
  return document.getElementById(WIDGET_SCRIPT_ID) != null || window[LOAD_GUARD_KEY] === true;
}

function injectGuideJar() {
  if (!shouldLoadGuideJar() || alreadyLoaded()) {
    return;
  }
  window[LOAD_GUARD_KEY] = true;

  const script = document.createElement("script");
  script.id = WIDGET_SCRIPT_ID;
  script.defer = true;
  script.src = WIDGET_SCRIPT_URL;
  script.setAttribute("data-help-center-id", "RzmoBPFg4mo88vIFbDfE");
  script.setAttribute("data-background-color", "#193837");
  script.setAttribute("data-position", "bottom-left");

  script.onerror = function () {
    window[LOAD_GUARD_KEY] = false;
    console.warn("Failed to load GuideJar widget");
  };

  document.body.appendChild(script);
}

/**
 * Schedule load after React's initial render and when the browser is idle.
 */
export function scheduleGuideJarWidget() {
  if (!shouldLoadGuideJar()) {
    return;
  }

  const run = function () {
    injectGuideJar();
  };

  if (typeof window.requestIdleCallback !== "undefined") {
    window.requestIdleCallback(run, { timeout: 5000 });
  } else {
    window.setTimeout(run, 2000);
  }
}
